
import Eraser from "../../../assets/outline/Eraser.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function EraserIcon({ className, dataTestid = "EraserIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Eraser data-testid={dataTestid} className={classes} {...rest} />
  );
}
